import React, { Component } from 'react';

class Collection extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header></header>
          <main>
            <table className="dsr" data-name="Collection">
              <thead>
                <tr>
                  <th colSpan={2} className="alert-brand">
                    {' '}
                    Collection
                  </th>
                </tr>
                <tr data-header={true}>
                  <th> Type </th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item.name}</td>
                      <td>
                        {new Intl.NumberFormat('en-IN', {
                          style: 'currency',
                          currency: 'INR',
                        }).format(item.total.toFixed(2) || 0)}
                      </td>
                    </tr>
                  );
                })}
                <tr className="summary-row">
                  <td colSpan="1">Total </td>
                  <td>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      summary.reduce((a, b) => a + (b['total'] || 0), 0) || 0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}

export default Collection;
